<template>
    <Link
        :href="route('groups.view', group.tra_id)"
        v-if="group"
        class="text-blue-600"
        >{{ group.title }}</Link
    >
    <span v-else>--</span>
</template>

<script>
export default {
    name: "MessageTableGroup",
    components: { },
    data() {
        return {};
    },
    methods: {},
    computed: {
        group() {
            return this.data.message_deliverable.group;
        }
    },
    props: {
        meta: {
            type: Object,
            default: () => {}
        },
        name: {
            type: String,
            default: ""
        },
        data: {
            type: Object,
            default: () => {}
        }
    }
};
</script>

<style scoped></style>
